import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../services/IsAuthenticated";
import { getSavedState } from "../services/localStorage";


interface RoleBasedRouteProps {
  allowedRoles: number[];
  redirectTo?: string;
}

const ProtectedRoute:  React.FC<RoleBasedRouteProps> = ({allowedRoles, 
  redirectTo = "/unauthorized"  }) => {
 // Check if user is authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  // Get user type from saved state
  const savedState = getSavedState("EMSUser");
  const userType = savedState?.data?.userTypeEnumValue;

  // Check if user has required role
  if (!userType || !allowedRoles.includes(userType )) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
